export default {
  state: {
    addresses: [],
    address: {
      debtor: {
        fullname: '',
      },
      contact_face: {
        fullname: '',
      },
      address: '',
    },
    departures: [],
  },
  mutations: {
    SET_ADDRESSES(state, payload) {
      state.addresses = payload.addresses;
    },
    SET_DEPARTURES(state, payload) {
      state.departures = payload.departures;
    },
    INIT_ADDRESS(state, payload) {
      state.address.id = payload.id;
      state.address.address = payload.address;
      if (payload.debtor) {
        state.address.contact_face = {};
        state.address.debtor.fullname = payload.debtor.fullname;
      }
      if (payload.contact_face) {
        state.address.debtor = {};
        state.address.contact_face.fullname = payload.contact_face.fullname;
      }
    },
    STORE_ADDRESSES(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    STORE_DEPARTURE_ADDRESS(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
  },
  actions: {
    async GET_ADDRESSES({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/debtor/${payload}/all/addresses`);
        commit('SET_ADDRESSES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_DEPARTURES({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/debtor/${payload}/all/departures`);
        commit('SET_DEPARTURES', data);
      } catch (err) {
        throw err;
      }
    },
    async INIT_ADDRESS({ commit }, payload) {
      try {
        commit('INIT_ADDRESS', payload);
      } catch (err) {
        throw err;
      }
    },
    async STORE_ADDRESSES({ commit }, payload) {
      try {
        let url = '';
        const { debtor_iin } = payload;
        if (payload.is_debtor) {
          url = `/debtor/addresses/${debtor_iin}`;
        } else {
          url = `/debtor/contactfaces/addresses/${debtor_iin}`;
        }
        const { data } = await window.axios.post(url, payload);
        commit('STORE_ADDRESSES', data);
      } catch (err) {
        throw err;
      }
    },
    async STORE_DEPARTURE_ADDRESS({ commit }, payload) {
      try {
        let url = '';
        const { debt_id } = payload;
        if (payload.is_debtor) {
          url = `/debtor/departures/${debt_id}`;
        } else {
          url = `/debtor/departures/contactface/${debt_id}`;
        }
        const { data } = await window.axios.post(url, payload);
        commit('STORE_DEPARTURE_ADDRESS', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    departures(state) {
      return state.departures;
    },
    addresses(state) {
      return state.addresses;
    },
    address(state) {
      return state.address;
    },
  },
};
